import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async me(): Promise<types.ResUserInfo> {
        const res = {} as types.ResUserInfo;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/me", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(param: types.ReqUserForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/me/modify", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async leave(): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/leave", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async pwConfirm(param: types.ReqConfirmPwForMyPage): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/pw/confirm", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async inquiryList(param: types.ReqCommonPaging): Promise<types.ResInquiryList> {
        const res = {} as types.ResInquiryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/inquiry/list", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async inquiryAdd(param: types.ReqInquiry): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/inquiry/add", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async inquiryModify(param: types.ReqInquiryForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/inquiry/modify", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async inquiryMultiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/inquiry/multi/delete", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async inquiryRemove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/inquiry/delete/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async boardList(param: types.ReqBoardList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/board/list", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async boardDetail(idx: number): Promise<types.ResBoard> {
        const res = {} as types.ResBoard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/board/detail/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async boardModify(idx: number, param: types.ReqBoardForSuggestForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/mypage/board/modify/" + idx, formData, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async boardRemove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/board/remove/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async boardMultiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/board/multi/remove", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportList(param: types.ReqBoardList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/report/list", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportDetail(idx: number): Promise<types.ResReport> {
        const res = {} as types.ResReport;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/report/detail/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportModify(idx: number, param: types.ReqReportForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/report/modify/" + idx, param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportRemove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/report/remove/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async reportMultiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/report/multi/remove", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async applyList(param: types.ReqBoardApplyList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/apply/list", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async applyDetail(idx: number): Promise<types.ResApplyForApi> {
        const res = {} as types.ResApplyForApi;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/apply/detail/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async applyModify(idx: number, param: types.ReqBoardApplyForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/apply/modify/" + idx, param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async applyListMultiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/apply/multi/remove", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detailForAnswer(boIdx: number): Promise<types.ResBoardApplyFormDetail> {
        let res = {} as types.ResBoardApplyFormDetail;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mypage/form/detail/" + boIdx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
